<template>
  <div>
    <div class="row" v-if="!loading">
      <div id="panel-template" class="panel-template" :class="panelLeft">
        <!-- //logo superior -->
        <!-- <div
          v-if="closingMessage[closingMessageType].useLogo"
          class="template-header"
        >
          <img :src="logo" />
        </div> -->
        <div class="template-body">
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label class="idx-bold" for="email-subject">
                  {{ $t('newAction.autoReplyText.emailSubject') }}
                </label>

                <input
                  type="text"
                  id="email-subject"
                  class="form-control"
                  :placeholder="
                    $t('newAction.autoReplyText.emailSubjectPlaceholder')
                  "
                  v-model="autoReply[automaticAnswer].subject"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label class="idx-bold" for="email-sender">
                  {{ $t('newAction.autoReplyText.emailSender') }}
                </label>

                <input
                  type="text"
                  id="email-sender"
                  class="form-control"
                  :placeholder="
                    $t('newAction.autoReplyText.emailSenderPlaceholder')
                  "
                  v-model="autoReply[automaticAnswer].sender"
                />
              </div>
            </div>
          </div>

          <wysiwyg
            api-key="no-api-key"  
            license_key="gpl2"
            tinymceScriptSrc="https://tinymce5.s3.amazonaws.com/tinymce/tinymce.min.js"
            :init="{
              menubar: false,
              statusbar: false,
              height: 600,
              language: this.$t('newAction.stepOne.editorLanguage'),
              plugins: 'link image lists hr emoticons',
              toolbar:
                'bold italic underline | alignleft aligncenter alignright alignjustify | link image | code | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight | styleselect ',
              lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
              font_formats:
                'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
              image_description: false,
              image_title: false,
              content_style:
                'img {max-width: 100%; max-height: 100%}, @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
              image_dimensions: false,
              file_picker_types: 'image',
              images_upload_handler: imagesUploadHandlerFooter,
              file_picker_callback: function (cb, value, meta) {
                uploadImgTinyMce(cb);
              },
              style_formats: [
                { title: 'Fontes customizada', format: 'p', disabled: true },
                {
                  title: 'Lato Regular',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '400',
                    fontStyle: 'normal',
                  },
                },
                {
                  title: 'Lato Medium',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '600',
                    fontStyle: 'normal',
                  },
                },
                {
                  title: 'Lato Bold',
                  inline: 'span',
                  styles: {
                    fontFamily: 'Lato',
                    fontWeight: '900',
                    fontStyle: 'normal',
                  },
                },
              ],
            }"
            v-if="panelLeft === 'col-8'"
            v-model="autoReply[automaticAnswer].html"
          />
          <div
            v-show="noEditor"
            id="body-email"
            class="no-editor"
            v-html="autoReply[automaticAnswer].html"
          ></div>
        </div>
      </div>
      <div id="config-template2" class="config-template" :class="panelRight">
        <div id="btn-actions" class="btn-actions">
          <button class="btn btn-primary" @click="expandPanel">
            <font-awesome-icon :icon="['fas', 'pen']" />
          </button>
        </div>
        <transition name="fade">
          <div v-if="panelOptions">
            <div class="row">
              <!-- <div class="col-12">
                <input
                  type="text"
                  class="form-control input-panel"
                  :value="`${this.$t('newAction.stepOne.topLogo')}`"
                  disabled
                />

                <div class="row custom-switch" style="padding-left: 35px;">
                  <div class="col-12">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="switch-logo-final-message"
                      v-model="closingMessage[closingMessageType].useLogo"
                    />
                    <label
                      class="custom-control-label"
                      for="switch-logo-final-message"
                      >{{ $t('newAction.stepOne.labels.able') }}</label
                    >
                  </div>
                </div>
              </div> -->
            </div>

            <div class="row mt-2">
              <div class="col-12">
                <span class="form-control input-panel">
                  <b>Configuração do template</b>
                </span>

                <p style="font-size: 0.8em;">
                  Você pode customizar a mensagem automática que o cliente
                  receberá no e-mail de acordo com a nota atribuída.
                </p>
                <p style="font-size: 0.8em;">
                  Selecione as escalas de notas abaixo e customize o layout do
                  e-mail:
                </p>
                <b-form-group>
                  <b-form-radio-group
                    id="auto-reply-radio-group"
                    name="auto-reply-radio"
                    v-model="automaticAnswer"
                  >
                    <b-form-radio style="font-size: 0.8em;" value="promoters">
                      {{ promotersText }}
                    </b-form-radio>
                    <b-form-radio
                      v-if="action.type !== 'like-dislike'"
                      style="font-size: 0.8em;"
                      value="passives"
                    >
                      {{ passivesText }}
                    </b-form-radio>
                    <b-form-radio style="font-size: 0.8em;" value="detractors">
                      {{ detractorsText }}
                    </b-form-radio>
                  </b-form-radio-group>
                </b-form-group>

                <span class="form-control input-panel"
                  ><b>Configurar tipo de resposta</b></span
                >
                <b-form-group>
                  <b-form-radio-group
                    id="type-answer-radio-group"
                    name="type-answer-radio"
                    v-model="typeAnswer"
                  >
                    <b-form-radio style="font-size: 0.8em;" value="immediate">
                      Imediato
                    </b-form-radio>
                    <b-form-radio
                      style="font-size: 0.8em;"
                      value="after30Minutes"
                    >
                      Após 30 minutos
                    </b-form-radio>
                    <b-form-radio style="font-size: 0.8em;" value="after1Hour">
                      Após 1 hora
                    </b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div v-else class="text-center">
      <b-spinner
        variant="success"
        type="grow"
        label="Spinning"
        class="bg-primary"
      ></b-spinner>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import api from '../../../../services/api';

export default {
  name: 'AutoReply',

  data: () => ({
    loading: false,
    wysiwygOptions: {
      hideModules: {
        table: true,
        separator: true,
        code: true,
        removeFormat: false,
      },
      image: {
        uploadURL: null,
        dropzoneOptions: {
          headers: {},
        },
      },
    },
    logo: null,
    apiRoot: null,
    preview: false,
    userAuth: null,
    panelLeft: 'col-11',
    panelRight: 'col-1',
    panelOptions: false,
    noEditor: true,
    automaticAnswer: 'promoters',
    promotersText: null,
    passivesText: null,
    detractorsText: null,
    typeAnswer: 'immediate',
  }),

  computed: {
    ...mapFields('actions', ['action', 'autoReply']),
    ...mapState('companies', ['company']),
  },

  watch: {
    typeAnswer: function watchTypeAnswer(value) {
      this.autoReply.typeAnswer = value;
    },

    '$i18n.locale': function watchLocale() {
      this.changeLabels();
    },
  },

  methods: {
    imagesUploadHandlerFooter(blobInfo, success, failure) {
      const xhr = new XMLHttpRequest();
      xhr.withCredentials = false;
      xhr.open('POST', `${process.env.API_ROOT}/image-footer/action`);
      xhr.setRequestHeader('x-access-token', this.userAuth.token);
      xhr.onload = function analise() {
        if (xhr.status !== 200) {
          failure(`HTTP Error: ${xhr.status}`);
          return;
        }
        const json = JSON.parse(xhr.responseText);

        if (!json || typeof json !== 'string') {
          failure(`Invalid JSON: ${xhr.responseText}`);
          return;
        }
        success(json);
      };

      const formData = new FormData();
      formData.append('file', blobInfo.blob(), blobInfo.filename());
      xhr.send(formData);
    },

    uploadImgTinyMce(cb) {
      const $input = document.createElement('input');
      $input.setAttribute('type', 'file');
      $input.setAttribute('accept', 'image/*');
      this.uploadedImageURL = this.image;
      $input.onchange = function onChangeImg() {
        const file = this.files[0];
        const reader = new FileReader();
        reader.onload = function readerImg() {
          const id = `blobid${new Date().getTime()}`;
          const blobCache = window.tinymce.activeEditor.editorUpload.blobCache;
          const base64 = reader.result.split(',')[1];
          const blobInfo = blobCache.create(id, file, base64);
          blobCache.add(blobInfo);
          cb(blobInfo.blobUri(), { title: file.name });
        };
        reader.readAsDataURL(file);
      };
      $input.click();
    },

    expandPanel() {
      if (this.panelRight === 'col-1') {
        this.panelLeft = 'col-8';
        this.panelRight = 'col-4';
        this.panelOptions = true;
        this.noEditor = false;
        document.getElementById('config-template2').style.backgroundColor =
          '#f1f1f1';
      } else {
        this.panelLeft = 'col-11';
        this.panelRight = 'col-1';
        this.panelOptions = false;
        this.noEditor = true;
        document.getElementById('config-template2').style.backgroundColor =
          '#fff';
      }
    },

    changeLabels() {
      if (this.action.type.includes('0-10')) {
        this.promotersText = this.$t(
          'newAction.autoReplyGrades.zeroToTen.promoters',
        );
        this.passivesText = this.$t(
          'newAction.autoReplyGrades.zeroToTen.passives',
        );
        this.detractorsText = this.$t(
          'newAction.autoReplyGrades.zeroToTen.detractors',
        );
      } else if (this.action.type === 'like-dislike') {
        this.promotersText = this.$t(
          'newAction.autoReplyGrades.zeroAndOne.promoters',
        );
        this.passivesText = '';
        this.detractorsText = this.$t(
          'newAction.autoReplyGrades.zeroAndOne.detractors',
        );
      } else {
        this.promotersText = this.$t(
          'newAction.autoReplyGrades.oneToFive.promoters',
        );
        this.passivesText = this.$t(
          'newAction.autoReplyGrades.oneToFive.passives',
        );
        this.detractorsText = this.$t(
          'newAction.autoReplyGrades.oneToFive.detractors',
        );
      }
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.wysiwygOptions.image.uploadURL = `${process.env.API_ROOT}/action/image-auto-reply/${this.userAuth.companyId}`;

    this.wysiwygOptions.image.dropzoneOptions.headers = {
      'x-access-token': this.userAuth.token,
    };
  },

  async mounted() {
    this.loading = true;
    this.apiRoot = process.env.API_ROOT;

    this.loading = true;

    // const logoUrl = process.env.INDECX_FILES_BUCKET;

    // if (this.action.uploadedImage) {
    //   this.logo = this.action.uploadedImage;
    // } else if (this.action.logo) {
    //   this.logo = `${logoUrl}/${this.action.logo}`;
    // } else {
    //   this.logo = `${logoUrl}/${this.company.logo}`;
    // }

    this.changeLabels();

    this.autoReply = {
      _id: null,
      default: {
        html: '<p>Obrigado por responder nossa pesquisa!</p>',
        sender: `${this.company.name}`,
        subject: `Avalie sua experiência com a ${this.company.name}`,
      },
      promoters: {
        html: '<p>Obrigado por responder nossa pesquisa!</p>',
        sender: `${this.company.name}`,
        subject: `Avalie sua experiência com a ${this.company.name}`,
      },
      passives: {
        html: '<p>Obrigado por responder nossa pesquisa!</p>',
        sender: `${this.company.name}`,
        subject: `Avalie sua experiência com a ${this.company.name}`,
      },
      detractors: {
        html:
          '<p>Sinto muito por não ter atendido suas expectativas. Obrigado!</p>',
        sender: `${this.company.name}`,
        subject: `Avalie sua experiência com a ${this.company.name}`,
      },
    };

    const response = await api.get(`action/auto-reply/${this.action._id}`, {
      headers: {
        'x-access-token': this.userAuth.token,
      },
    });

    if (response.data) {
      this.autoReply = response.data;
    }

    this.typeAnswer = this.autoReply.typeAnswer;

    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.row {
  padding: 0 14px;
}

.panel-template {
  transition: all 0.2s linear;

  padding: 0 30px 0 0;
  > div {
    margin-top: 10px;
    &:first-of-type {
      margin-top: 0;
    }
  }

  .template-header {
    border: 1px dashed $gray;
    padding: 10px;
    text-align: center;

    img {
      height: 70px;
    }
  }
  .template-body {
    border: 1px dashed $gray;
    padding: 10px;
  }
}

.config-template {
  transition: all 0.2s linear;
  padding-top: 17px;
  padding-left: 30px;
  margin-top: -17px;
  background-color: #fff;
  position: relative;
  min-height: 330px;
  .input-panel {
    background-color: transparent;
    padding: 0;
    border: none;
    font-size: 0.9em;
    margin-top: 10px;
    font-weight: bold;
    &:first-of-type {
      margin-top: 10px;
    }
  }
  .btn-actions {
    display: flex;
    flex-direction: column;
    width: 40px;
    position: absolute;
    left: -20px;
    .btn {
      margin-bottom: 5px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
    .preview {
      margin: 5px 0;
    }
  }

  .custom-control-label {
    font-size: 0.8em;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.btn-view {
  max-width: 40px;
}

@media (max-width: 1500px) {
  .config-template {
    position: absolute;
    top: 57px;
    right: 20px;
  }
}
</style>

<style scoped>
.no-editor img {
  max-width: 100%;
}

.no-editor {
  min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/action-templates/automatic-answer/index.vue